if (!customElements.get('ss-product-carousel')) {
  customElements.define('ss-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-ss-rail]');
      this.prev = this.querySelector('[data-ss-prev]');
      this.next = this.querySelector('[data-ss-next]');
      if (!this.rail) return;

      this.step = Number(this.dataset.scrollBy) || 1;
      this.onScroll = SS.rafThrottle(this.updateNav.bind(this));

      this.prev?.addEventListener('click', () => this.scrollByCards(-1));
      this.next?.addEventListener('click', () => this.scrollByCards(1));
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });

      this.ro = new ResizeObserver(SS.debounce(() => this.updateNav(), 150));
      this.ro.observe(this.rail);

      if (this.hasAttribute('data-recommendations')) {
        this.loadRecommendations();
      }

      this.updateNav();
    }

    disconnectedCallback() {
      this.rail?.removeEventListener('scroll', this.onScroll);
      this.ro?.disconnect();
    }

    scrollByCards(dir) {
      const slide = this.rail.firstElementChild;
      if (!slide) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const distance = (slide.offsetWidth + gap) * this.step * dir;
      this.rail.scrollBy({ left: distance, behavior: SS.reduceMotion() ? 'auto' : 'smooth' });
    }

    updateNav() {
      if (!this.prev || !this.next) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.rail;
      const max = scrollWidth - clientWidth;

      if (max <= 1) {
        this.prev.hidden = true;
        this.next.hidden = true;
        return;
      }
      this.prev.hidden = scrollLeft <= 1;
      this.next.hidden = scrollLeft >= max - 1;
    }

    async loadRecommendations() {
      const params = new URLSearchParams({
        section_id: this.dataset.sectionId,
        product_id: this.dataset.productId,
        limit: this.dataset.limit || '12',
        intent: this.dataset.intent || 'related'
      });

      try {
        const res = await fetch(`${SS.routes.root}recommendations/products?${params}`);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const rail = doc.querySelector('[data-ss-rail]');

        if (!rail || !rail.children.length) {
          this.hidden = true;
          return;
        }

        this.rail.innerHTML = rail.innerHTML;
        this.updateNav();
        window.ssScanAnimations?.(this.rail);
      } catch (err) {
        console.error('SS — recommandations :', err);
        this.hidden = true;
      }
    }
  });
}